module.exports = __webpack_public_path__ + "static/assets/48d66af328a669a1c84c5dc87a4e9a3b.ttf";